module.exports = __webpack_public_path__ + "img/04n.3bb6a2b8.svg";